import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { authClient } from '../lib/auth-client';
import styles from '../components/auth/BaseModal.module.css';

export function PasswordResetPage() {
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const canSubmit = useMemo(() => {
    return !!token && !!newPassword && !!confirmPassword && newPassword === confirmPassword;
  }, [token, newPassword, confirmPassword]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');
    const tokenParam = params.get('token');

    if (error === 'INVALID_TOKEN') {
      setErrorMessage('Token inválido ou expirado.');
    } else if (tokenParam) {
      setToken(tokenParam);
    }
  }, []);

  async function handleResetPassword(e: any) {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setErrorMessage('As senhas não conferem.');
      return;
    }

    setLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    const { error } = await authClient.resetPassword({
      token,
      newPassword,
    });

    if (error) {
      setErrorMessage(error.message || 'Erro ao resetar senha');
      setLoading(false);
      return;
    }

    setSuccessMessage('Senha resetada com sucesso!');
    setNewPassword('');
    setConfirmPassword('');
    setLoading(false);
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2 className={styles.title}>Reset de senha</h2>
          <p className={styles.subtitle}>
            Defina uma nova senha para acessar a aplicação.
          </p>
        </div>

        <div className={styles.body}>
          {errorMessage ? (
            <p className={styles.errorMessage}>{errorMessage}</p>
          ) : successMessage ? (
            <div className={styles.successBlock}>
              <p className={styles.successMessage}>{successMessage}</p>
              <Link to="/" className={styles.textLink}>
                Voltar para a página inicial
              </Link>
            </div>
          ) : (
            <form onSubmit={handleResetPassword} className={styles.body}>
              <div className={styles.formGroup}>
                <label className={styles.label}>Nova senha</label>
                <input
                  type="password"
                  className={styles.input}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  disabled={loading}
                  placeholder="mínimo 8 caracteres"
                />
              </div>

              <div className={styles.formGroup}>
                <label className={styles.label}>Confirmar senha</label>
                <input
                  type="password"
                  className={styles.input}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  disabled={loading}
                  placeholder="repita a nova senha"
                />
              </div>

              <div className={styles.actions}>
                <button
                  type="submit"
                  className={`${styles.button} ${styles.buttonPrimary}`}
                  disabled={loading || !canSubmit}
                >
                  {loading ? 'Resetando...' : 'Resetar senha'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
